module.exports = __webpack_public_path__ + "img/Konstruktion_Holzdeck.10e9c450.jpg";